import React, { useState } from 'react';
import { Nav, NavItem, NavLink, Row, Col } from 'reactstrap';

// Types
interface DemographicItem {
  id: string;
  demographic_type: string;
  demographic_title: string;
  distance_from_property: string;
  description: string;
  property_id: string;
  createdAt: string;
  updatedAt: string;
}

interface DemographicsData {
  transit: DemographicItem[];
  parksRecreation: DemographicItem[];
  education: DemographicItem[];
  foodDrinks: DemographicItem[];
}

interface DemographicsProps {
  demographicsData: DemographicsData;
}

const Demographics: React.FC<DemographicsProps> = ({ demographicsData }) => {
  const [activeTab, setActiveTab] = useState('transit');
  // Define tab mapping for cleaner logic
  const tabDataMap: Record<string, DemographicItem[]> = {
    'transit': demographicsData.transit,
    'parks & recreation': demographicsData.parksRecreation,
    'education': demographicsData.education,
    'food & drink': demographicsData.foodDrinks,
  };

  // Select data based on tab
  const data = tabDataMap[activeTab] || [];

  // Transform API data to display format
  const transformedData = data.map(item => ({
    name: item.demographic_title,
    distance: item.distance_from_property,
    type: item.description 
  }));

  // Split data into rows of 2
  const rows = [];
  for (let i = 0; i < transformedData.length; i += 2) {
    rows.push(transformedData.slice(i, i + 2));
  }

  return (
    <div>
      <Nav pills className="nav nav-tabs nav-tabs-custom nav-success nav-justified ">
        <NavItem>
          <NavLink
            active={activeTab === 'transit'}
            onClick={() => setActiveTab('transit')}
            style={{ cursor: 'pointer', fontWeight: 500, fontSize: 18, textTransform: 'capitalize' }}
          >
            Transit
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={activeTab === 'parks & recreation'}
            onClick={() => setActiveTab('parks & recreation')}
            style={{ cursor: 'pointer', fontWeight: 500, fontSize: 18 }}
          >
            Parks & Recreation
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={activeTab === 'education'}
            onClick={() => setActiveTab('education')}
            style={{ cursor: 'pointer', fontWeight: 500, fontSize: 18 }}
          >
            Education
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={activeTab === 'food & drink'}
            onClick={() => setActiveTab('food & drink')}
            style={{ cursor: 'pointer', fontWeight: 500, fontSize: 18 }}
          >
            Food & Drink
          </NavLink>
        </NavItem>
      </Nav>
      <div className="mt-2">
        {transformedData.length === 0 ? (
          <div className="text-center py-4">
            <div className="text-muted">
              <i className="ri-map-pin-line" style={{ fontSize: '2rem' }}></i>
              <p className="mt-2">No {activeTab} data available</p>
            </div>
          </div>
        ) : (
          rows.map((row, idx) => (
            <Row key={idx} className="mb-3">
              {row.map((item, j) => (
                <Col md={6} key={j} className="mb-3">
                  <div
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: 4,
                      padding: '18px 20px',
                      background: '#fff',
                      minHeight: 90
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span style={{ fontWeight: 600, fontSize: 18 }}>{item.name}</span>
                      <span style={{ fontWeight: 500, fontSize: 17 }}>{`${item.distance} miles`}</span>
                    </div>
                    <div style={{ color: '#444', fontSize: 16 }}>{item.type}</div>
                  </div>
                </Col>
              ))}
            </Row>
          ))
        )}
      </div>
    </div>
  );
};

export default Demographics;